import { z } from "zod";

export const ContactSchema = z.object({
  name: z.string(),
  email: z.string().email(),
  calling_no: z.string().min(10).max(10),
  whatsapp_no: z.string().min(10).max(10),
  state: z.string(),
  city: z.string(),
  pin: z.string().min(6).max(6),
  subject: z.string(),
  message: z.string(),
})